import { HttpBase, HttpGlobalConfig } from 'zy-http-base'
import { CachedUserInfo } from '@/services/CachedStorages'
import { Message } from 'element-ui'
import router from '@/router'

const httpClient = new HttpBase(new HttpGlobalConfig(
  process.env.httpBaseUrl,
  null,
  {
    'x-zhsq-source': 'web-tenement-mgmt',
  },
  6000,
  (err) => {
    const { code } = err.payload

    if (code === 'USER_NOT_LOGGED_IN') {
      const route = router.app.$route
      router.replace({ name: 'login', query: { redirect: route.name } })
    } else if (code === 'CSRF_FAILED') {
      Message.warning({
        message: '认证失败，请刷新页面重试'
      })
    }
  },
  () => {
    return CachedUserInfo.get() && CachedUserInfo.get().csrftoken
  },
  (msg) => {
    Message.error({
      message: msg,
      duration: 0,
      showClose: true
    })
  },
  null
))

let getBlockUrl = function(url) {
  // 如果真的出了意外拿不到blockId，这里将其赋值为0，
  // 从而让URL正确，后台会返回session过期的值。
  let blockId = CachedUserInfo.get().block_id || 0
  return `block/${blockId}/${url}`
}

export const get = async function(url, options) {
  return httpClient.get(url, options)
}

export const post = async function(url, data, options) {
  return httpClient.post(url, data, options)
}

export const blockGet = async function(url, options) {
  return get(getBlockUrl(url), options)
}

export const blockPost = async function(url, data, options) {
  return post(getBlockUrl(url), data, options)
}

export const blockPostWithLongTimeout = async function(url, data, options) {
  // set timeout to 25 seconds
  if (options === undefined) {
    options = {}
  }
  options.timeout = 25000
  return post(getBlockUrl(url), data, options)
}

export default {
  get,
  post,
  blockGet,
  blockPost
}
